<template>
    <div class="component-budget-graph">
        <el-card class="box-card">
            <div class="row">
                <div class="col-12">
                    <div class="chart-container" :id="'chart-container-'+title" style="position: relative; height: 0px; width:">
                        <canvas @click="chartClicked($event)" :id="`${title}`"></canvas>
                    </div>
                    <div v-if="!loaded" class="loader-container">
                        <facebook-loader :speed="3" :animate=true :height=130 :width=400></facebook-loader>
                    </div>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import { dataConvertDict } from '../../chart/ChartData'
import { colors, getHeadersWithAccessToken } from '../../functions.js'
import axios from '@/services/axios.js'
import { FacebookLoader } from 'vue-content-loader'
import Chart from 'chart.js'
// eslint-disable-next-line
import chartjsPluginAnnotation from 'chartjs-plugin-annotation'

function hexToRgbA (hex, opacity) {
    var c
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + opacity + ')'
    } else { return hex }
}
export default {
    data () {
        return {
            chart: {},
            loaded: false,
            endpoint: '/budget/budget/summary',
            title: 'budgetsummary'

        }
    },
    components: {
        FacebookLoader
    },
    methods: {
        chartClicked (event) {
            try {
                var activePoints = this.chart.getElementsAtEvent(event)
                var firstPoint = activePoints[0]
                var label = this.chart.data.labels[firstPoint._index]
                let year = label.split('-')[0]
                let week = label.split('-')[1].replace('W', '')
                this.$router.push({ 'name': 'budget-budget', 'query': { 'week': week, 'year': year, 'level': this.$route.query.level } })
            } catch (error) {
                //
            }
        },
        draw (individualStore = undefined) {
            this.loaded = false

            // Get the container and set its size to 0px to make room for the loading animation
            var container = document.getElementById('chart-container-' + this.title)
            container.style.height = '0px'

            // Get the ctx and payload for the request
            var ctx = document.getElementById(`${this.title}`).getContext('2d')
            var payload = {
                'format': 'doa',
                'store_id': this.$store.getters['budget/getStoreIds'],
                'year': this.$route.query.year,
                'week': this.$route.query.week,
                'user_id': localStorage.getItem('user_id'),
                'level': this.$route.query.level
            }

            return axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at' + this.endpoint, payload, { headers: getHeadersWithAccessToken() })
                .then(response => {
                    // Get data for the chart
                    var chartData = {}
                    chartData = dataConvertDict[this.title](response.data.data)
                    // Generate the chart
                    const datasets = this.handleData(chartData['data'])
                    const scales = this.handleScales(chartData['scales'])
                    var myChart = new Chart(ctx, {
                        type: chartData['type'],
                        data: {
                            datasets,
                            labels: chartData['labels']
                        },
                        options: {
                            plugins: {
                                datalabels: {
                                    display: false
                                }
                            },
                            responsive: true,
                            maintainAspectRatio: false,
                            legend: {
                                display: true
                            },
                            tooltips: {
                                enabled: true
                            },
                            scales: {
                                xAxes: scales.xAxes,
                                yAxes: scales.yAxes
                            }
                        }
                    })
                    this.loaded = true

                    // Get the container and increase its height from 0px to 350/450px
                    let container = document.getElementById('chart-container-' + this.title)
                    container.style.height = '350px'
                    return myChart
                })
                .catch(error => {
                    console.log(error)
                })
        },
        handleData (data) {
            return data.map((item, index) => {
                return {
                    type: item.type,
                    yAxisID: item.yAxisID,
                    label: item.label,
                    data: item.data,
                    fill: 'fill' in item ? item.fill : true,
                    backgroundColor: 'backgroundColor' in item ? hexToRgbA(item.backgroundColor, 0.3) : hexToRgbA(colors[index], 0.3),
                    borderColor: 'borderColor' in item ? hexToRgbA(item.borderColor, 1) : hexToRgbA(colors[index], 1),
                    borderWidth: 2,
                    lineTension: 'lineTension' in item ? item.lineTension : 0.4,
                    radius: 'radius' in item ? item.radius : 0,
                    borderDash: 'borderDash' in item ? item.borderDash : [0, 0]
                }
            })
        },
        handleScales (scales) {
            let returnData = { 'yAxes': [], 'xAxes': [] }
            for (let y of scales.yAxes) {
                let ax = {
                    id: y.id,
                    stacked: y.stacked,
                    position: y.position,
                    scaleLabel: {
                        display: true,
                        labelString: y.label,
                        fontSize: 14
                    },
                    gridLines: {
                        display: false
                    },
                    ticks: {
                        fontSize: 14,
                        min: 'min' in y ? y.min : 0
                    }
                }
                returnData['yAxes'].push(ax)
            }
            let ax = {
                id: 'X',
                stacked: scales.xAxes.stacked,
                scaleLabel: {
                    display: true,
                    labelString: scales.xAxes.label,
                    fontSize: 14
                },
                gridLines: {
                    display: false
                },
                ticks: {
                    fontSize: 14,
                    beginAtZero: true,
                    userCallback: function (item, index) {
                        if (!(index % 0)) return item
                    }
                }
            }
            returnData['xAxes'].push(ax)
            return returnData
        }
    },
    mounted () {
        this.draw().then(response => {
            this.chart = response
        })
    }
}

</script>

<style lang="scss">
.component-budget-graph {
    margin-bottom: 50px;
}
</style>
